import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpUpdateIsCoverGalleryImg,
	httpUpdateIsCoverGalleryImg
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useUpdateIsCoverGalleryImg = (
	urlParams: Omit<HttpUpdateIsCoverGalleryImg['urlParams'], 'imgId'>,
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpUpdateIsCoverGalleryImg['payload'] &
			Pick<HttpUpdateIsCoverGalleryImg['urlParams'], 'imgId'>
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpUpdateIsCoverGalleryImg({
				urlParams: { ...urlParams, imgId: payload.imgId },
				payload,
				params: {
					response_type: 'small'
				}
			}),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.SERVICE_GALLERY_IMAGES]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
